import head from 'lodash/head';
import keys from 'lodash/keys';

export default function(cartItems, screenZoneData) {
    /**
     * If we have a current cart:
     * Select the screen containing the first seat.
     * Or, select first screen
     */
    let selectedScreenNo = head(keys(screenZoneData));
    if (cartItems.length) {
        for (var i in screenZoneData) {
            screenZoneData[i].zones.map(function (zone) {
                if (zone === cartItems[0].zone_no) {
                    selectedScreenNo = i;
                }
            });
        }
    }

    return selectedScreenNo;
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/seatmaps/preselectScreen.js